/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ListSalesPackageTiersParams,
  SalesPackageTier,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary List package tiers for the sales request wizard
 */
export const listSalesPackageTiers = (
    params?: MaybeRefOrGetter<ListSalesPackageTiersParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<SalesPackageTier[]>(
      {url: `/sales/package_tiers`, method: 'GET',
        params, signal
    },
      );
    }




export const getListSalesPackageTiersQueryKey = (params?: MaybeRefOrGetter<ListSalesPackageTiersParams>,) => {
    return [
    'sales','package_tiers', ...(params ? [params] : [])
    ] as const;
    }


export const getListSalesPackageTiersQueryOptions = <TData = Awaited<ReturnType<typeof listSalesPackageTiers>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<ListSalesPackageTiersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSalesPackageTiers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListSalesPackageTiersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listSalesPackageTiers>>> = ({ signal }) => listSalesPackageTiers(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listSalesPackageTiers>>, TError, TData>
}

export type ListSalesPackageTiersQueryResult = NonNullable<Awaited<ReturnType<typeof listSalesPackageTiers>>>
export type ListSalesPackageTiersQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary List package tiers for the sales request wizard
 */

export function useListSalesPackageTiers<TData = Awaited<ReturnType<typeof listSalesPackageTiers>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<ListSalesPackageTiersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listSalesPackageTiers>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListSalesPackageTiersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






